import React, {
  useEffect
} from "react";
import {
  Avatar,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  TextField
} from "@mui/material";
import { PropaneTankOutlined } from "@mui/icons-material";
import { DatePicker } from "@mui/x-date-pickers";
import { format, parseISO, isValid } from "date-fns";

const GasConsume = ({
    state,
    setState,
    previousData,
    gasRequired,
    errors
  }) => {

  function parseDateValue(value) {
    if (!value) return null;
    if (value instanceof Date) return isValid(value) ? value : null;
    if (typeof value === 'string') {
      const parsed = parseISO(value);
      return isValid(parsed) ? parsed : null;
    }
    return null;
  }

  function readingHelperText() {
    if (errors && errors.previous_reading_date) {
      return errors.previous_reading_date;
    } else if (previousData && previousData.previousDate) {
      const parsed = parseDateValue(previousData.previousDate);
      return parsed ? `Última data de leitura: ${format(parsed, 'dd/MM/yyyy')}` : '';
    } else {
      return '';
    }
  }

  useEffect(function stateFill() {
    const updates = {};
    if (!state?.previous_reading_amount && previousData?.previousReading) {
      updates.previous_reading_amount = previousData.previousReading;
    }
    if (!state?.previous_reading_date && previousData?.previousDate) {
      const parsed = parseDateValue(previousData.previousDate);
      if (parsed) {
        updates.previous_reading_date = format(parsed, 'yyyy-MM-dd');
      }
    }
    if (!state?.current_reading_date) {
      updates.current_reading_date = format(new Date(), 'yyyy-MM-dd');
    }
    if (Object.keys(updates).length > 0) {
      setState(prevState => ({...prevState, ...updates}));
    }
  }, [previousData])

  return (
    <Grid
      item
      xs={12}
    >
      {state?.category === 'GAS' &&
        <Card>
          <CardHeader
            avatar={<Avatar sx={{bgcolor: 'primary.main'}}><PropaneTankOutlined/></Avatar>}
            title={'Consumo de Gás'}/>
          <Divider
            sx={{
              mb: '.3rem'
            }}
          />
          <CardContent>
            <Grid
              container
              spacing={2}
            >
              <Grid
                item
                xs={6}
              >

                <DatePicker
                  views={['year', 'month', 'day']}
                  label="Data da Leitura Anterior"
                  value={parseDateValue(state?.previous_reading_date)}
                  onChange={(newValue) => setState((prevState) => ({
                    ...prevState,
                    previous_reading_date: newValue && isValid(newValue) ? format(newValue, 'yyyy-MM-dd') : ''
                  }))}
                  slotProps={{
                    textField: {
                      size: 'small',
                      fullWidth: true,
                      required: true,
                      error: !!errors?.previous_reading_date,
                      helperText: readingHelperText(),
                      placeholder: 'dd/mm/aaaa',
                    }
                  }}
                />

              </Grid>
              <Grid item xs={6}>
                <DatePicker
                  views={['year', 'month', 'day']}
                  label="Data da Leitura Atual"
                  value={parseDateValue(state?.current_reading_date)}
                  onChange={(newValue) => setState((prevState) => ({
                    ...prevState,
                    current_reading_date: newValue && isValid(newValue) ? format(newValue, 'yyyy-MM-dd') : ''
                  }))}
                  slotProps={{
                    textField: {
                      size: 'small',
                      fullWidth: true,
                      required: true,
                      error: !!errors?.current_reading_date,
                      helperText: errors?.current_reading_date || '',
                      placeholder: 'dd/mm/aaaa',
                    }
                  }}
                />

              </Grid>
              <Grid item xs={6}>
                <TextField
                  label="Leitura Anterior"
                  size={'small'}
                  fullWidth
                  type={'text'}
                  value={state?.previous_reading_amount?.toString().replace(/[^0-9.,]/g, '') ?? ''}
                  onChange={(e) =>
                    setState((prevState) => ({
                      ...prevState,
                      previous_reading_amount: e.target.value?.replace(/[^0-9.,]/g, '')
                    }))}
                  error={!!errors?.previous_reading_amount}
                  helperText={errors?.previous_reading_amount ? errors.previous_reading_amount : previousData?.previousReading ? `Última leitura: ${previousData?.previousReading}` : ''}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label="Leitura Atual"
                  size={'small'}
                  fullWidth
                  type={'text'}
                  required={!!gasRequired}
                  value={state?.current_reading_amount?.replace(/[^0-9.,]/g, '') ?? ''}
                  onChange={(e) => setState((prevState) => ({
                    ...prevState,
                    current_reading_amount: e.target.value?.replace(/[^0-9.,]/g, '')
                  }))}
                  error={!!errors?.current_reading_amount}
                  helperText={errors?.current_reading_amount}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      }
    </Grid>
  )
}

export default GasConsume